var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1404 4.827C16.1407 4.827 16.1411 4.82735 16.1418 4.82807L17.172 5.85843C17.1727 5.85896 17.1729 5.85932 17.1731 5.85985C17.1732 5.86021 17.1732 5.86057 17.1731 5.86093C17.1731 5.86146 17.1727 5.86182 17.172 5.86253L12.0345 11L17.172 16.1375C17.1727 16.1382 17.1729 16.1386 17.1731 16.1391C17.1732 16.1395 17.1732 16.14 17.1731 16.1404C17.1731 16.1407 17.1727 16.1411 17.172 16.1418L16.1416 17.172C16.1411 17.1727 16.1407 17.1729 16.1404 17.1731C16.14 17.1732 16.1395 17.1732 16.1391 17.1731C16.1386 17.1731 16.1382 17.1727 16.1375 17.172L11 12.0345L5.86253 17.172C5.86182 17.1727 5.86146 17.1729 5.86093 17.1731C5.86052 17.1732 5.86008 17.1732 5.85968 17.1731C5.85932 17.1731 5.85896 17.1727 5.85825 17.172L4.82807 16.1416C4.82735 16.1411 4.82718 16.1407 4.827 16.1404C4.82687 16.14 4.82687 16.1395 4.827 16.1391C4.827 16.1386 4.82735 16.1382 4.82807 16.1375L9.96557 11L4.82807 5.86253C4.82735 5.86182 4.82718 5.86146 4.827 5.86093C4.82687 5.86052 4.82687 5.86008 4.827 5.85968C4.827 5.85932 4.82735 5.85896 4.82807 5.85825L5.85843 4.82807C5.85896 4.82735 5.85932 4.82718 5.85968 4.827C5.86008 4.82687 5.86052 4.82687 5.86093 4.827C5.86146 4.827 5.86182 4.82735 5.86253 4.82807L11 9.96557L16.1375 4.82807C16.1382 4.82735 16.1386 4.82718 16.1391 4.827C16.1395 4.82687 16.14 4.82687 16.1404 4.827Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseX);
export default __webpack_public_path__ + "static/media/close-x.774d1bc6e2d191fd736e6dfa6d23da1b.svg";
export { ForwardRef as ReactComponent };